import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import NoImageFound from "../../Util/NoImageFound";

import CardList from "./CardList";
import Slider from "react-slick";

export const ListRendering = ({ dataListing, loading }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: true,
    loop: true,
    items: 4,
    responsive: [
      {
        breakpoint: 1320,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
        },
      },
    ],
  };
  return (
    <>
      <div
        className={
          dataListing?.length == undefined || dataListing?.length == 0
            ? "productdetails withError"
            : "productdetails"
        }
      >
        <div className="container-fluid custom-container">
          <>
            <div className="productlist mt-3 vs-productlist">
              <div className="row">
                {loading ? (
                  <div className="row">
                    <Slider {...settings}>
                      {Array.from({ length: 4 }).map((_, index) => (
                        <div
                          className="col"
                          style={{ display: "contents" }}
                          key={index}
                        >
                          <Skeleton height={250} />
                        </div>
                      ))}
                    </Slider>
                  </div>
                ) : dataListing?.length > 0 ? (
                  <Slider {...settings}>
                    {dataListing.map((v, index) => (
                      <CardList key={index} propertylisting={v} />
                    ))}
                  </Slider>
                ) : (
                  <h4>No results found</h4>
                )}
              </div>
            </div>
          </>
        </div>
      </div>
    </>
  );
};
